module.exports = __webpack_public_path__ + "static/media/auditorium.f3f3da6c.png";